(function () {
  function openHashDetails() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    var target;
    try {
      target = document.querySelector(hash);
    } catch (e) {
      return;
    }
    if (!target) return;
    var details = target.tagName === 'DETAILS' ? target : target.closest('details');
    if (!details) return;
    details.open = true;
    window.requestAnimationFrame(function () {
      details.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openHashDetails);
  } else {
    openHashDetails();
  }
  window.addEventListener('hashchange', openHashDetails);
})();
